var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeLinks.length)?_c('div',[_c('hr'),_vm._v(" "),_vm._l((_vm.activeLinks),function(link,index){return _c('p',{key:index},[_c('router-link',{class:link.class,attrs:{"to":link.routerInfo}},[_vm._v("\n      "+_vm._s(link.display)+"\n    ")])],1)})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }